import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import './SubmissionCycle.css';
import ReviewModalWindow from '../review-modal-window/ReviewModalWindow';
import PreloaderOverlay from '../../../shared/components/presentation/preloader-overlay/PreloaderOverlay';
import sendRequest from "../../functions/sendRequest";

const getSubmissionMessage = (attempt) => {
  const messages = [
    { title: "1 of 2", message: "We're trying to submit your request." },
    { title: "2 of 2", message: "Let's try this one more time." },
    { title: "1 of 2", message: "We're trying again to submit your request." },
    { title: "2 of 2", message: "Let's try this one more time." }
  ];
  return messages[attempt] || messages[0];
};

const SubmissionCycle = ({ onRetry, onSuccess, state }) => {
  const [attempts, setAttempts] = useState(0);
  const [submissionMessage, setSubmissionMessage] = useState(getSubmissionMessage(0));
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [submissionSucceeded, setSubmissionSucceeded] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (isModalVisible || submissionSucceeded) {
        // Prevent further submissions if the modal is visible or if the submission has succeeded
        return;
    }

    setSubmissionMessage(getSubmissionMessage(attempts));
    submitForm(attempts);
  }, [attempts, isModalVisible, submissionSucceeded]);

  const handleRetry = () => {
    setIsModalVisible(false);
    onRetry();
    setAttempts(2);
  };

  const handleSubmissionFailure = (currentAttempt) => {
    const newAttempt = currentAttempt + 1;
    setAttempts(newAttempt);

    if (newAttempt === 2) {
      setIsLoading(false);
      setIsModalVisible(true);
    } 
    else if (newAttempt === 4) {
      setIsLoading(false);
      handleFinalFailure();
    }
  };
  
  const handleFinalFailure = () => {
    setIsModalVisible(false);
    history.push("/webappointment/error-review");
  };

  const submitForm = async (currentAttempt = 0) => {
    setIsLoading(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      const success = await sendRequest(state);

      if (success) {
        setIsLoading(false);
        setSubmissionSucceeded(true);
        onSuccess(success);
      } 
      else {
        throw new Error("Submission failed");
      }
    } 
    catch {
      handleSubmissionFailure(currentAttempt);
    }
  };
  
  return (
    <div>
      {isLoading && (
        <PreloaderOverlay 
          title={submissionMessage.title} 
          message={submissionMessage.message} 
        />
      )}

      {isModalVisible && (
        <ReviewModalWindow
          closeFunc={handleFinalFailure}
          onRetry={handleRetry}
          isVisible={true}
        />
      )}
    </div>
  );
};

SubmissionCycle.propTypes = {
  onRetry: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired
};

export default SubmissionCycle;